import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

interface GetMasterCompanyDataI {
  id: number,
  company_code: string,
  code_segment: string,
  desc_segment: string,
  is_active: string,
  create_at: string,
  create_by: string
}

interface GetMasterCompanyResponseI {
  list_mtcompany_segment: GetMasterCompanyDataI[]
}

export const url = "/v1/cfmtcompanysegment";

export const getSegmentsByCompany = async (
  companyId: string,
): Promise<GetMasterCompanyResponseI> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${companyId}/true`,
    method: "GET",
  });

  return data;
};
